import commonUtil from '../../../utils/commonUtil';

export const SEARCHED_PRODUCT_LOAD = 'SEARCHED_PRODUCT_LOAD';
export const SEARCHED_PRODUCT_LOAD_SUCCESS = 'SEARCHED_PRODUCT_LOAD_SUCCESS';
export const SEARCHED_PRODUCT_LOAD_FAIL = 'SEARCHED_PRODUCT_LOAD_FAIL';

export function loadSearchedDetailOfPoduct(globalState) {
  return globalState.SearchedPoductData && globalState.SearchedPoductData.loaded;
}

export function SearchedDetailOfPoduct(searchTerm, newPayload) {
  const userEnteredData = {};
  userEnteredData.searchTerm = searchTerm;
  userEnteredData.brandName = commonUtil.getBrand().toUpperCase();
  userEnteredData.channel = 'WEB';
  userEnteredData.newPayload = newPayload;  //  Changes for GR Serach Facade
  return {
    types: [SEARCHED_PRODUCT_LOAD, SEARCHED_PRODUCT_LOAD_SUCCESS, SEARCHED_PRODUCT_LOAD_FAIL],
    promise: client => client.post('/api/search/typeAhead', {
      data: (userEnteredData),
    }),
  };
}
